import { render, staticRenderFns } from "./DeleteClientPerson.vue?vue&type=template&id=ba19736c&scoped=true"
import script from "./DeleteClientPerson.vue?vue&type=script&lang=ts"
export * from "./DeleteClientPerson.vue?vue&type=script&lang=ts"
import style0 from "./DeleteClientPerson.vue?vue&type=style&index=0&id=ba19736c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba19736c",
  null
  
)

export default component.exports